import { ReactNode } from "react";
import { Dialog } from "radix-ui";
import { Trans, useTranslation } from "react-i18next";

import { SvButton } from "@/components";
import { I18nKeyType } from "@/i18n";

type SvDialogProps = (
  | {
      titleKey?: I18nKeyType;
      title?: never;
    }
  | {
      titleKey?: never;
      title: ReactNode | string;
    }
) & {
  trigger: ReactNode;
  children?: ReactNode | ReactNode[];
};

export const SvDialogBasic = ({
  trigger,
  titleKey,
  title,
  children,
}: SvDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="data-[state=open]:animate-fadeIn data-[state=closed]:animate-fadeOut fixed inset-0 bg-black/40" />
        <Dialog.Content className="data-[state=open]:animate-fadeIn data-[state=closed]:animate-fadeOut fixed top-1/2 left-1/2 flex max-h-[90%] w-[85%] -translate-x-1/2 -translate-y-1/2 flex-col rounded-lg bg-white py-10 md:w-[70%] lg:w-auto">
          <Dialog.Title className="px-10 text-xl font-semibold">
            {titleKey && <Trans i18nKey={titleKey} />}
            {Boolean(title) && title}
          </Dialog.Title>
          <Dialog.Description className="my-6 overflow-y-scroll px-10 md:text-base md:leading-6">
            {children}
          </Dialog.Description>

          <Dialog.Close asChild>
            <div className="px-10 text-right">
              <SvButton
                color="neutral"
                variant="outline"
                className="w-full md:w-auto">
                <span>{t("common.close")}</span>
              </SvButton>
            </div>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
